import { useInfiniteQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useGetGratitudes = (params = {}, queryOptions = {}) => {
  const { filters = { associationType: 'recognition' }, pagination: { limit = 10 } = {} } = params;

  return useInfiniteQuery(
    ['gratitudes', limit],
    ({ pageParam = 1 }) => {
      return services.getThankYouNotes(
        cleanObjectEmptyFields({
          pagination: {
            limit,
            page: pageParam
          },
          filters
        })
      );
    },
    {
      getNextPageParam: lastPage => {
        const { totalDocs, page, limit } = lastPage;
        const totalPages = Math.ceil(totalDocs / limit);
        return page < totalPages ? page + 1 : undefined;
      },
      ...queryOptions
    }
  );
};
